import { render, staticRenderFns } from "./ClienteEscolha.vue?vue&type=template&id=06ae6152"
import script from "./ClienteEscolha.vue?vue&type=script&lang=js"
export * from "./ClienteEscolha.vue?vue&type=script&lang=js"
import style0 from "./ClienteEscolha.vue?vue&type=style&index=0&id=06ae6152&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports